import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "environments/environment";
import { RootState } from "../../product/product.store";
import { ShippingMethodInterface } from "../../../interfaces/credit/shipping-method.interface";

export const fetchShippingMethodsThunk = createAsyncThunk<ShippingMethodInterface[], void>(
    'credits/fetchShippingMethods', async (_, { getState }) => {
        const state = (getState() as RootState).credit;
        const result = await axios.post<ShippingMethodInterface[]>(`${environment.urls.credits.shippingMethods}`, {
            productId: state.productId,
        })
        return result.data;
    }
);